// Product Selectors
export const selectProductsByChoice = (state, choiceId) => {
  const choiceBasedProducts = (state?.choiceBasedProducts || {});
  return choiceBasedProducts[choiceId]?.products || [];
};

export const selectCachedProductsByChoice = (state, choiceId) => {
  const choiceBasedCachedProducts = (state?.fetchedCachedData || {});
  return choiceBasedCachedProducts[choiceId]?.cachedData || [];
};

export const selectProductKeyFeatures = (product) => {

  const keyFeatures = (product?.keyProductFeatures || []);
  return keyFeatures;

};
export const selectProductKeyFeaturesFromKpfItems = (product) => {
  const keyFeatures = (product?.keyProductFeatures?.keyProductFeaturesItems || []);
  return keyFeatures[0]?.features || [];
};

export const selectProductKeyFeaturesMap = (product,
  overrideKey = (feat) => feat?.name,
  overrideValue = (feat) => feat?.value) => {
  const keyFeatures = selectProductKeyFeatures(product);
  let feautureMap = {};

  keyFeatures.forEach((feat) => {
    const featName = overrideKey(feat);
    if (!featName) {
      return;
    }

    feautureMap[featName] = overrideValue(feat);
  });

  return feautureMap;
};

function getProductKeyFeatureByName(product, featureName) {
  const keyProductFeatures = selectProductKeyFeatures(product);
  return keyProductFeatures.find((feat) => feat?.name.toLowerCase() === featureName.toLowerCase());
}

function getKpfByName(product, featureName) {
  const keyProductFeatures = selectProductKeyFeaturesFromKpfItems(product);
  return keyProductFeatures.find((feat) => feat?.name.toLowerCase() === featureName.toLowerCase());
}

export const selectProductKeyFeatureByName = (product, featureName) => {
  return getKpfByName(product, featureName)?.value;
};

export const hasProductKeyFeatureByName = (product, featureName) => {
  return getProductKeyFeatureByName(product, featureName);
};

export const isKeyFeatureValuesInProduct = (product, filters, op = 'AND') => {
  const featureMap = selectProductKeyFeaturesMap(product,
    (feat) => {
      const featName = feat?.name || '';
      if (featName.includes('Width')) {
        return 'Width';
      }
      if (featName.includes('Height')) {
        return 'Height';
      }

      return featName;
    },
    (feat) => {
      const featName = feat?.name || '';
      if (featName.includes('Width') || featName.includes('Height')) {
        return feat?.value?.replace(' in', '"');
      }

      return feat?.value;
    }
  );
  let isMatch = false;

  if (op === 'AND') {
    let matchCount = 0;

    filters.forEach((filter) => {
      const productFeatureValue = featureMap[filter.name];
      if (filter.values.includes(productFeatureValue)) {
        matchCount += 1;
      }
    });

    if (filters.length === matchCount) {
      isMatch = true;
    }
  } else { // or
    for (let i = 0; i < filters.length && !isMatch; i += 1) {
      const productFeatureValue = featureMap[filters[0].name];
      if (filters[0].values.includes(productFeatureValue)) {
        isMatch = true;
      }
    }
  }

  return isMatch;
};

// Sections Selectors
export const selectSectionsByChoice = (state, choiceId) => {
  const metadata = (state?.choiceMetadata || {});
  return metadata[choiceId]?.sections || [];
};

export const selectSectionFilterByName = (section, filterName) => {
  return section.filters?.find((filter) => filter.attributeName === filterName);
};

export const selectSectionFilterValuesByName = (section, filterName) => {
  const filter = selectSectionFilterByName(section, filterName);
  return filter?.attributeValues;
};

export const selectSectionCabinetTypes = (section) => {
  return selectSectionFilterValuesByName(section, 'Cabinet Type');

};

const matchProductToCategory = (productCategories, categories) => {
  const hierarchy = productCategories?.categoryHierarchy || [];
  return categories.some((category) => hierarchy.includes(category));
};

const matchProductToKPF = (product, filter) => {
  const productFeature = getProductKeyFeatureByName(product, filter.attributeName);

  if (!productFeature) {
    return filter.attributeValues.includes('NULL');
  }
  return filter.attributeValues.find((validValue) => (
    productFeature.value.toLowerCase() === validValue.toLowerCase()
    || (validValue.includes('*') && (new RegExp(validValue, 'i')).test(productFeature.value))
    || validValue === 'ANY'
  ));
};

export const productMatchesFilter = (product, filter, productCategories) => {

  switch (filter.attributeName.toLowerCase()) {
  case 'category':
    return matchProductToCategory(productCategories, filter.attributeValues);
  default:
    return matchProductToKPF(product, filter);
  }
};

export const selectSectionProductsByChoice = (state, choiceId) => {
  const sections = selectSectionsByChoice(state, choiceId);
  const products = selectProductsByChoice(state, choiceId);
  const cachedProducts = selectCachedProductsByChoice(state, choiceId);

  const { fetchedCategories } = state;
  const sectionMap = {};
  sections.forEach((curSection) => {
    if (curSection.filters) {
      sectionMap[curSection.Name] = products.filter((curProd) => {
        const prodCategories = fetchedCategories
          ? fetchedCategories[choiceId]?.categories?.find((item) => item.itemId === curProd.itemId) : [];
        return curSection.filters.every((filter) => productMatchesFilter(curProd, filter, prodCategories));
      }) || [];
    } else {
      sectionMap[curSection.Name] = products;
    }
  });
  return sectionMap;
};

export const selectCachedSectionProductsByChoice = (state, choiceId) => {
  const sections = selectSectionsByChoice(state, choiceId);
  const products = selectProductsByChoice(state, choiceId);
  const cachedproducts = selectCachedProductsByChoice(state, choiceId);
  const { fetchedCategories, fetchedCachedData } = state;
  const sectionMap = {};

  sections.forEach((curSection) => {
    if (curSection.filters) {
      const choicebasedproducts = products.filter((curProd) => {
        const prodCategories = fetchedCategories
          ? fetchedCategories[choiceId]?.categories?.find((item) => item.itemId === curProd.itemId)
          : [];
        return curSection.filters.every((filter) => productMatchesFilter(curProd, filter, prodCategories));
      });

      const cachedchoicebasedproducts = cachedproducts.filter((curProd) => {
        const prodCategories = fetchedCategories
          ? fetchedCategories[choiceId]?.categories?.find((item) => item.itemId === curProd.itemId)
          : [];
        return curSection.filters.every((filter) => {
          const test = productMatchesFilter(curProd, filter, prodCategories);
          return test;
        });
      });
      sectionMap[curSection.Name] = {
        products: choicebasedproducts,
        cachedProducts: cachedchoicebasedproducts,
      };

    } else {
      sectionMap[curSection.Name] = {
        products,
        cachedProducts: [],
      };
    }
  });

  return sectionMap;
};